import { ActiveSession } from "../../context/AuthContext";

export const Spinner = () => (
  <svg
    className="h-4 w-4 animate-spin text-slate-400"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
    />
  </svg>
);

export const currencyFmt = (amount: number, currency: string) => {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `${amount} ${currency}`;
  }
};

export const fmt = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleString() : "Unknown";

const truncateUserAgent = (userAgent: string | null) => {
  if (!userAgent) {
    return null;
  }

  const firstParen = userAgent.indexOf("(");
  if (firstParen > 0) {
    return userAgent.slice(0, firstParen).trim();
  }

  return userAgent.slice(0, 60).trim();
};

export const deviceLabel = (session?: ActiveSession | null) => {
  if (!session) {
    return "Unknown device";
  }

  const device = session.device;
  const parts: string[] = [];

  if (device?.name) {
    parts.push(device.name);
  }

  const agent = truncateUserAgent(device?.userAgent ?? null);
  if (agent) {
    parts.push(agent);
  }

  if (device?.ipAddress) {
    parts.push(`IP: ${device.ipAddress}`);
  }

  if (parts.length === 0) {
    return "Unknown device";
  }

  return parts.join(" · ");
};

export const getTrialRemainingDays = (
  trialEndsAt: string | Date | null
): number => {
  if (!trialEndsAt) return 0;
  const end = new Date(trialEndsAt).getTime();
  const now = Date.now();
  const diff = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
  return Math.max(diff, 0);
};

export const formatDate = (iso: string | Date | null) => {
  if (!iso) return "Not active";
  return new Date(iso).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
